import {
  GET_PENSION_VERIFICATION_LIST,
  GET_PENSION_VERIFICATION_LIST_SUCCESS,
  GET_PENSION_VERIFICATION_LIST_FAILURE,
  GET_PENSION_VERIFICATION,
  GET_PENSION_VERIFICATION_SUCCESS,
  GET_PENSION_VERIFICATION_FAILURE,
  POST_REGENERATE_PENSION_VERIFICATION,
  POST_REGENERATE_PENSION_VERIFICATION_SUCCESS,
  POST_REGENERATE_PENSION_VERIFICATION_FAILURE,
} from './constant';

// Get Pension Verification List API actions.
export const getPensionVerificationList = (account, token) => ({
  type: GET_PENSION_VERIFICATION_LIST,
  payload: { account, token },
});
export const getPensionVerificationListSuccess = (data) => ({
  type: GET_PENSION_VERIFICATION_LIST_SUCCESS,
  payload: { data },
});
export const getPensionVerificationListFailure = (error) => ({
  type: GET_PENSION_VERIFICATION_LIST_FAILURE,
  payload: { error },
});

export const getPensionVerification = (planId, documentId, token) => ({
  type: GET_PENSION_VERIFICATION,
  payload: { planId, documentId, token },
});

export const getPensionVerificationSuccess = (data) => ({
  type: GET_PENSION_VERIFICATION_SUCCESS,
  payload: { data },
});

export const getPensionVerificationFailure = (error) => ({
  type: GET_PENSION_VERIFICATION_FAILURE,
  payload: { error },
});

export const postRegeneratePensionVerification = (account, token) => ({
  type: POST_REGENERATE_PENSION_VERIFICATION,
  payload: { account, token },
});

export const postRegeneratePensionVerificationSuccess = (data) => ({
  type: POST_REGENERATE_PENSION_VERIFICATION_SUCCESS,
  payload: { data },
});

export const postRegeneratePensionVerificationFailure = (error) => ({
  type: POST_REGENERATE_PENSION_VERIFICATION_FAILURE,
  payload: { error },
});

export const resetPensionPDF = () => ({
  type: 'RESET_PENSION_PDF',
});


